import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    name: null,
    permission: []
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        // Action ini akan menerima objek "data" dari backend sebagai payload
        setUserData: (state, action) => {
            state.name = action.payload.name;
            state.permission = action.payload.permission;
        },
        // Opsional: Untuk membersihkan data saat user logout
        clearUserData: (state) => {
            state.name = null;
            state.permission = [];
        }
    }
});

export const { setUserData, clearUserData } = userSlice.actions;
export default userSlice.reducer;